<script lang="ts" setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
    <path d="M3.5 5L6.53109 0.5H0.468911L3.5 5Z" fill="white" />
  </svg>
</template>
